import { Component, Input, OnInit } from '@angular/core';
import { DestroyableComponent } from '../../base/destroyable.component';
import { Observable } from 'rxjs';
import { OnlineService } from '../../services/online/online.service';

@Component({
    selector: 'tvcore-online-status',
    templateUrl: './online-status.component.html',
    styleUrls: ['./online-status.component.scss'],
    standalone: false
})
export class OnlineStatusComponent extends DestroyableComponent implements OnInit {
	@Input()
	backgroundImage: string;
	@Input()
	brandName: string;

	online$: Observable<boolean>;

	constructor(private onlineService: OnlineService) {
		super();
	}

	ngOnInit() {
		this.online$ = this.onlineService.checkOnline(this.destroyed$);
	}
}
